import React, {useEffect, useState} from 'react';
import utils from "utils";
import {Calendar} from "primereact/calendar";
import "./calendar.scss";
import {InputText} from "primereact/inputtext";

export function CalendarCustomer(props) {
    const [value, setValue] = useState(props.value)
    const [min, setMin] = useState()

    function _handleChange(e) {
        setValue(e.target.value);
        props.onChange(e);
    }

    function _handleBlur(e) {

    }

    //   useEffect(() => {
    //     let date=new Date(utils.convertDateTime(props.value));
    //     setValue(new Date(date))
    // }, []);

    useEffect(() => {
      //  const unixTime =parseFloat(props.value);
        setValue(utils.formatDateSu(props.value))
    }, []);


    return (
        <div className="p-inputgroup  span-mrg">
            {props.icon ? <span className="p-inputgroup-addon span-mrg-icon ">
                                          <i className={props.icon}></i>
                            </span> : ''}
            <span className="p-float-label ">
                   {/*<Calendar*/}
                {/*    id={props.id}*/}
                {/*    value={value}*/}
                {/*    name={props.name}*/}
                {/*    onChange={_handleChange}*/}
                {/*    dateFormat="dd/mm/yy"*/}
                {/*    minDate={props.min}*/}
                {/*    maxDate={props.max}*/}
                {/*    onFocus={props.onFocus}*/}
                {/*    monthNavigator*/}
                {/*    yearNavigator*/}
                {/*    yearRange="2020:3100"*/}
                {/*    disabled={props.disabled}*/}
                {/*    className={`${props.icon ? 'span-mrg-input-date-piker ' : 'span-mrg-input-no-icon'} p-inputtext-trashy date-header p-inputtext-date`}*/}
                {/*    required={props.required}*/}
                {/*    showButtonBar={true}*/}
                {/*    onBlur={props.onBlur}*/}
                {/*/>*/}
                <InputText
                    id={props.id}
                    value={value}
                    type='Date'
                    name={props.name}
                    onChange={_handleChange}
                    type="Date"
                    format="dd-mm-yyyy"
                    size={props.size}
                    // placeholder={props.placeholder}
                    onFocus={props.onFocus}
                    autocomplete={props.autocomplete}
                    autocapitalize={props.autocapitalize}
                    autocorrect={props.autocorrect}
                    disabled={props.disabled}
                    min="01-01-2022"
                    max={props.max}
                    className={`${props.icon ?
                        ((props.type === 'password' && !props.noShow) ? 'span-mrg-input-p' : 'span-mrg-input') :
                        ((props.type === 'password' && !props.noShow) ? 'span-mrg-input-no-icon-p' : 'span-mrg-input-no-icon')} p-inputtext-trashy`}
                    required={props.required}
                    toggleMask={props.toggleMask}
                    InputProps={{

                    }}
                    onBlur={_handleBlur}/>

                <label className='label' htmlFor={props.id}>{props.label}
                    {props.required ? <span className='validate_required'> *</span> : ''}
                    {props.validate ? <span className='validate_required'>{' ' + props.validate}</span> : ''}
            </label>
          </span>

        </div>

    );
}